/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 9.3.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OsrmWaypoint
 */
export interface OsrmWaypoint {
  /**
   *
   * @type {string}
   * @memberof OsrmWaypoint
   */
  name?: string;
  /**
   * A (longitude, latitude) coordinate pair.
   * @type {Array<number>}
   * @memberof OsrmWaypoint
   */
  location: Array<number>;
  /**
   * The distance of the snapped point from the original location.
   * @type {number}
   * @memberof OsrmWaypoint
   */
  distance: number;
  /**
   *
   * @type {string}
   * @memberof OsrmWaypoint
   */
  hint?: string;
}

/**
 * Check if a given object implements the OsrmWaypoint interface.
 */
export function instanceOfOsrmWaypoint(value: object): value is OsrmWaypoint {
  if (!("location" in value) || value["location"] === undefined) return false;
  if (!("distance" in value) || value["distance"] === undefined) return false;
  return true;
}

export function OsrmWaypointFromJSON(json: any): OsrmWaypoint {
  return OsrmWaypointFromJSONTyped(json, false);
}

export function OsrmWaypointFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OsrmWaypoint {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"] == null ? undefined : json["name"],
    location: json["location"],
    distance: json["distance"],
    hint: json["hint"] == null ? undefined : json["hint"],
  };
}

export function OsrmWaypointToJSON(json: any): OsrmWaypoint {
  return OsrmWaypointToJSONTyped(json, false);
}

export function OsrmWaypointToJSONTyped(
  value?: OsrmWaypoint | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    location: value["location"],
    distance: value["distance"],
    hint: value["hint"],
  };
}
